const regex = /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@[*[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+]*/

export function validateEmail(email: string): boolean {
  return regex.test(email);
}

// TODO: add domain typo corrections here
